import React, { useEffect, useState } from 'react';
import GraphButton from '../../../../GraphButton';
import {
  addChild,
  addFather,
  addMother,
  autoArrange,
  getFather,
  getMother,
  getNodeId,
  hasRelation,
  onBtnUpdateParents,
  onNodeSuggestion,
} from '../../../scripts/cy-core';
import { InputNumber, Space } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

const ConnectedNodes = () => {
  const currentNode = useSelector((state) => state.tree.currentNode);
  let [minFatherBranch, setMinFatherBranch] = useState(1);
  let [minMotherBranch, setMinMotherBranch] = useState(1);

  // suggest father from keyword input
  function onFatherSuggestion(e) {
    onNodeSuggestion(e, onFatherSelection, fatherFilter);
  }

  const fatherFilter = (aFather) => {
    if (aFather.data('gender') === 'f') {
      // debug-console.log('Skip father suggestion: Female ' + aFather.data('name'));
      return false;
    }

    if (hasRelation(aFather.id(), getNodeId())) {
      // debug-console.log(        'Skip father suggestion: hasRelation(aFather.id(), getNodeId()):' + aFather.data('name'),      );
      return false;
    }
    return true;
  };

  function onFatherSelection(e) {
    // when click on suggestion
    addFather({ id: getNodeId(e) });
  }

  function onMotherSuggestion(e) {
    onNodeSuggestion(e, onMotherSelection, motherFilter);
  }

  const motherFilter = (aMother) => {
    if (aMother.data('gender') === 'm') {
      // debug-console.log('Skip mother suggestion: male ' + aMother.data('name'));
      return false;
    }

    if (hasRelation(aMother.id(), getNodeId())) {
      // debug-console.log(        'Skip mother suggestion: hasRelation(aMother.id(), getNodeId()) ' + aMother.data('name'),      );
      return false;
    }
    return true;
  };

  function onMotherSelection(e) {
    // when click on suggestion
    addMother({ id: getNodeId(e) });
  }

  function onChildSuggestion(e) {
    onNodeSuggestion(e, onChildSelection, childFilter);
  }

  const childFilter = (aChild) => {
    if (hasRelation(aChild.id(), getNodeId())) {
      //        // debug-console.log('Skip relation suggestion: '+ aChild.data('name'));
      return false;
    }
    return true;
  };

  function onChildSelection(e) {
    // when click on suggestion
    addChild({ id: getNodeId(e) });
  }

  const onGenerateFatherBranch = () => {
    const level = document.getElementById('fatherBranchLevel').value;

    // debug-console.log(`onGenerate FatherBranch: for=${currentNode.name}, level=${level}`);

    let father = getFather(currentNode.id);
    if (father.empty()) {
      father = addFather({ name: `Bố của ${currentNode.name}` });
    } else {
      // debug-console.log('onGenerate FatherBranch: getFather=', father.data('name'));
    }

    generateParents(father, level - 1);
    autoArrange();
  };

  const onGenerateMotherBranch = () => {
    const level = document.getElementById('motherBranchLevel').value;

    // debug-console.log(`onGenerate MotherBranch: for=${currentNode.name}, level=${level}`);

    let mother = getMother(currentNode.id);
    if (mother.empty()) {
      mother = addMother({ name: `Mẹ của ${currentNode.name}` });
    } else {
      // debug-console.log('onGenerate MotherBranch: getMother=', mother.data('name'));
    }

    generateParents(mother, level - 1);
    autoArrange();
  };

  const generateParents = (node, level) => {
    // debug-console.log('generate parents: loop');
    let father, mother;
    for (let index = 0; index < level; index++) {
      // debug-console.log(`${index} ----------------------`);
      father = getFather(null, node);
      if (father.empty()) {
        father = addFather({ name: `Bố của ${node.data('name')}` }, { id: node.id() });
        // // debug-console.log(index + '. + Father=', father);
      }

      mother = getMother(null, node);
      if (mother.empty()) {
        mother = addMother({ name: `Mẹ của ${node.data('name')}` }, { id: node.id() });
        // // debug-console.log(index + '. + Mother=', mother);
      }
      node = father;
    }
  };

  const onGenerateChildren = () => {
    const childrenNumber = document.getElementById('childrenNumber').value;

    // debug-console.log('onGenerate children: level=', childrenNumber);
    // // debug-console.log('onGenerate children: currentNode=', currentNode);

    let child;
    for (let index = 0; index < childrenNumber; index++) {
      child = addChild({ name: `Con của ${currentNode.name} - ${index + 1}` }, true);
      // debug-console.log(index + '. + Child=', child);
    }

    autoArrange();
  };

  const countParentLevel = (node) => {
    let father, mother;
    let level = 0;
    do {
      father = getFather(null, node);
      if (father.empty()) {
        // // debug-console.log(level + '. Father is empty');
        break;
      }

      mother = getMother(null, node);
      if (mother.empty) {
        // // debug-console.log(level + '. Mother is empty');
        break;
      }
      node = father;
      level += 1;
    } while (!node.isEmpty());
    return level;
  };

  const calculateMinFatherBranch = () => {
    let minLevel = 1;
    let father = getFather(currentNode.id);
    // // debug-console.log('calculate MinFatherBranch: getFather=', father);
    if (!father.empty()) {
      minLevel += 1;
    }

    minLevel += countParentLevel(father);
    // // debug-console.log('calculate MinFatherBranch: result=', minLevel);
    setMinFatherBranch(minLevel);
    document.getElementById('fatherBranchLevel').value = minLevel;
  };

  const calculateMinMotherBranch = () => {
    let minLevel = 1;
    let mother = getMother(currentNode.id);
    // // debug-console.log('calculate MinMotherBranch: getMother=', mother);
    if (!mother.empty()) {
      minLevel += 1;
    }

    minLevel += countParentLevel(mother);
    // // debug-console.log('calculate MinMotherBranch: result=', minLevel);
    setMinMotherBranch(minLevel);
    document.getElementById('motherBranchLevel').value = minLevel;
  };

  useEffect(() => {
    // // debug-console.log('[Use Effect] ConnectedNodes ---------');
    if (currentNode.id) {
      calculateMinFatherBranch();
      calculateMinMotherBranch();
    }
  }, [currentNode]);

  return (
    <div id="connectedNodes" className="nodeInfo tab-pane fade">
      <table id="connectedNodes" className="infoTable">
        <tbody>
          <tr>
            <td>
              <label htmlFor="sourceNode">Bố</label>
            </td>
            <td>
              <div className="connectedNode" id="father" />
              <input
                type="text"
                className="form-control text-height-60 fatherSuggestion"
                id="sourceNode"
                name="sourceNode"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Chọn từ những Người đã có hoặc thêm Người mới"
                onKeyUp={onFatherSuggestion}
                onClick={(e) => {
                  onFatherSuggestion(e);
                  e.stopPropagation();
                }}
              />
              <div className="suggestions" />
            </td>
            <td>
              <Space direction="horizontal">
                <InputNumber
                  id="fatherBranchLevel"
                  min={minFatherBranch}
                  max={5}
                  style={{ width: 52 }}
                />
                <PlusSquareOutlined
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Tự động thêm các đời họ nội"
                  onClick={onGenerateFatherBranch}
                  style={{ color: 'green', transform: 'scale(1.3)' }}
                />
              </Space>
            </td>
          </tr>

          <tr>
            <td>
              <label htmlFor="sourceNode2">Mẹ</label>
            </td>
            <td>
              <div className="connectedNode" id="mother" />
              <input
                type="text"
                className="form-control text-height-60 motherSuggestion"
                id="sourceNode2"
                name="sourceNode2"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Chọn từ những Người đã có hoặc thêm Người mới"
                onKeyUp={onMotherSuggestion}
                onClick={(e) => {
                  onMotherSuggestion(e);
                  e.stopPropagation();
                }}
              />
              <div className="suggestions" />
            </td>
            <td>
              <Space direction="horizontal">
                <InputNumber
                  id="motherBranchLevel"
                  min={minMotherBranch}
                  max={5}
                  style={{ width: 52 }}
                />
                <PlusSquareOutlined
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Tự động thêm các đời họ ngoại"
                  onClick={onGenerateMotherBranch}
                  style={{ color: 'green', transform: 'scale(1.3)' }}
                />
              </Space>
            </td>
          </tr>

          <tr>
            <td style={{ verticalAlign: 'top' }}>
              <label>Con</label>
            </td>
            <td>
              <div>
                <input
                  type="text"
                  className="form-control text-height-60 childSuggestion"
                  id="targetNode"
                  name="targetNode"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Chọn từ những Người đã có hoặc thêm Người mới"
                  onKeyUp={onChildSuggestion}
                  onClick={(e) => {
                    onChildSuggestion(e);
                    e.stopPropagation();
                  }}
                />
                <div className="suggestions" />
                <div className="connectedNode" id="children" />
              </div>
            </td>
            <td style={{ verticalAlign: 'top' }}>
              <Space direction="horizontal">
                <InputNumber id="childrenNumber" min={1} max={10} style={{ width: 52 }} />
                <PlusSquareOutlined
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Tự động thêm con"
                  onClick={onGenerateChildren}
                  style={{ color: 'green', transform: 'scale(1.3)' }}
                />
              </Space>
            </td>
          </tr>

          <tr>
            <td></td>
            <td />
          </tr>
          <tr className="hide">
            <td>
              <label className="top">Thông tin</label>
            </td>
            <td>
              <textarea
                type="text"
                className="form-control text-height-60"
                placeholder=""
                id="nodeData"
                name="nodeData"
              />
              <GraphButton
                id="btnUpdateNodeData"
                label="Update"
                title="Cập nhật thông tin chỉnh sửa"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <GraphButton
        disabled={true}
        id="btnUpdateParents"
        label="Thêm"
        onClick={onBtnUpdateParents}
        title="Thêm Bố, Mẹ hoặc Con của người đang chọn"
      />
    </div>
  );
};
export default ConnectedNodes;
